<script setup>
  import {computed} from 'vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const props = defineProps({
    label: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'btn--primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const buttonLabel = computed(() => {
    if(props.loading) {
      return t('button.loading');
    } else {
      return props.label;
    }
  });
</script>
<template>
  <button class="btn"
          :class="{'btn--disabled': disabled, 'btn--has-feedback': loading }, type"
          :aria-live="loading ? 'polite' : null"
          :aria-busy="loading"
          :disabled="disabled"
          type="submit">
    <span class="btn__label">{{ buttonLabel }}</span>
    <span class="btn__icon" v-if="loading">
      <span class="icon icon--is-loading">
        <svg class="active" width="34" height="34" viewBox="0 0 467 577" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-0.000762939 576.536L466.443 576.536V490.587L-0.000762939 490.587V576.536Z" fill="#002d52" stroke="#002d52" stroke-width="15" class="k-logo-elem-1"></path>
            <path d="M349.989 406.762L181.035 247.376C178.124 244.583 174.281 243.105 170.218 243.105H83.132L83.2419 406.817H0V6.10352e-05H83.2419V161.687H169.723C173.732 161.632 177.52 160.099 180.431 157.416L350.044 6.10352e-05H467L251.757 202.095L466.176 406.762H349.989Z" fill="white" stroke="#fff" stroke-width="15" class="k-logo-elem-2"></path>
        </svg>
      </span>
    </span>
  </button>
</template>